import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index']);
  const modifyTrunkRulesConfig = `modifyTrunkRulesConfig(input: ${dataModify})`;

  return gql`
  mutation {
    ${modifyTrunkRulesConfig} {
      id
    }
  }
`;
};
